import { useEffect, useState } from "react";
import { EventModel } from "../models/EventModel";

type CacheEntry = {
    events: EventModel[];
    ts: number;
};

let eventsCache: CacheEntry = { events: [], ts: 0 };

export function usePopular(options?: { maxAgeMs?: number }) {

    const maxAgeMs = options?.maxAgeMs ?? (60000 * 60); // 1h

    const cached = eventsCache;
    const [events, setEvents] = useState<EventModel[]>(cached?.events ?? []);
    const [loading, setLoading] = useState<boolean>(!cached);

    useEffect(() => {
        const now = Date.now();
        const cacheHit = eventsCache;
        const fresh = cacheHit && now - cacheHit.ts < maxAgeMs;

        if (fresh) {
            setEvents(cacheHit!.events);
            setLoading(false);
            return;
        }

        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const response = await fetch(`/api/events/popular`);
            if (!response.ok) {
                throw new Error();
            }
            const data = await response.json();
            eventsCache = { events: data, ts: Date.now() };
            setEvents(data);
        } catch (err: any) {
            console.error('Error fetching popular events:', err);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    return {
        events,
        loading
    };

}
